module.exports = __webpack_public_path__ + "img/email.9f278d5a.svg";